import React, { useMemo } from 'react'
import { Input, Label } from 'reactstrap'

/**
 * BRD-driven per-tab status filter.
 *
 * Each tab has specific BRD-defined status options that the backend
 * supports via the statusFilter parameter.
 *
 * Contract:
 * - parentTab: 'pending' | 'auction' | 'bid-review' | 'sold'
 * - value: string key of the selected BRD status
 * - onChange: (nextValue: string) => void
 */
const SellerTabStatusFilter = ({ parentTab, value, onChange }) =>
{
	const options = useMemo(() =>
	{
		switch (parentTab)
		{
			case 'auction':
				return [
					{ key: 'all', label: 'All' },
					{ key: 'AwaitingInspection', label: 'Pending – Awaiting Inspection' },
					{ key: 'AwaitingRTBI', label: 'Pending – Awaiting RTBI' },
					{ key: 'AwaitingPricing', label: 'Awaiting Pricing' },
					{ key: 'Hold', label: 'Hold' },
					{ key: 'AwaitingSellerRelease', label: 'Awaiting Seller Release' },
					{ key: 'Released', label: 'Released' },
					{ key: 'Live', label: 'Live' },
					{ key: 'LiveOpen', label: 'Live Open' },
				]
			case 'bid-review':
				return [
					{ key: 'all', label: 'All' },
					{ key: 'BidReview', label: 'Bid Review' },
					{ key: 'CounterPending', label: 'Counter Pending' },
				]
			case 'sold':
				return [
					{ key: 'all', label: 'All' },
					{ key: 'Sold', label: 'Sold' },
					{ key: 'Voided', label: 'Voided' },
				]
			case 'pending':
			default:
				return [
					{ key: 'all', label: 'All' },
					{ key: 'Unsold', label: 'Unsold' },
					{ key: 'Shipping', label: 'Shipping' },
					{ key: 'Cancelled', label: 'Cancelled' },
					{ key: 'PhysicalAuction', label: 'Physical Auction' },
					{ key: 'Ungrounded', label: 'Ungrounded' },
				]
		}
	}, [parentTab])

	return (
		<div style={{ display: 'flex', justifyContent: 'center' }}>
			<div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
				<Label style={{ marginBottom: 0, fontSize: 'smaller' }}>Status</Label>
				<Input
					type="select"
					value={ value || 'all' }
					onChange={ (e) => onChange(e.target.value) }
					style={{ width: '360px' }}
				>
					{options.map((o) => (
						<option key={ o.key } value={ o.key } disabled={ !!o.disabled }>
							{o.label}
						</option>
					))}
				</Input>
			</div>
		</div>
	)
}

export default SellerTabStatusFilter
